package com.appsyde.shared.modules.invite.data.source

/** Données de prévisualisation d'une invitation (boîte support, invitant). */
data class InvitePreview(val supportInbox: String, val inviterName: String)

interface InviteAcceptDataSource {
    /** Envoie le token d'invitation avec le cookie pre-auth. Retourne un résultat typé (succès, déjà utilisée, invalide, etc.). */
    suspend fun acceptInvite(token: String): AcceptInviteResult

    /** Récupère supportInbox et inviterName pour un token valide (sans auth). Utilisé quand l'URL n'a pas le paramètre inbox. */
    suspend fun getPreview(token: String): InvitePreview?
}
